import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationGroup1MasterReferenceData = createAsyncThunk(
  'stop/getVerificationGroup1MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationGroup1MasterReferenceSlice = createSlice({
  name: 'stop/verificationGroup1MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationGroup1MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationGroup1MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationGroup1MasterReference } =
  verificationGroup1MasterReferenceSlice.actions;

export default verificationGroup1MasterReferenceSlice.reducer;
